import { useState } from "react";
import HiddenTab from "component/tab";
import InsuranceCardList from "./List";
import CreateInsuranceCard from "./Create";

export interface ITabData {
  activeKey: string;
  data?: {
    copiedId: number;
  };
}
interface IInsuranceCardProps {
  isStaff: boolean
}


export default function InsuranceCard({ isStaff }: IInsuranceCardProps) {
  const [tab, setTab] = useState<ITabData>({
    activeKey: "list",
  });

  const tabItems = [
    {
      key: "list",
      children: (
        <InsuranceCardList
          onChangeTab={setTab}
          isActive={tab.activeKey === "list"}
          isStaff={isStaff}
        />
      ),
    },
    {
      key: "create",
      children: (
        <CreateInsuranceCard
          copiedId={tab.data?.copiedId}
          onChangeTab={setTab}
          isActive={tab.activeKey === "create"}
          isStaff={isStaff}
        />
      ),
    },
  ];
  return (
    <div>
      <HiddenTab activeKey={tab.activeKey} onChange={setTab} items={tabItems} />
    </div>
  );
}
